import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { Handle } from 'src/app/handle';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { GatewayService } from 'src/app/gateway.service';

@Component({
  selector: 'app-create-rol',
  templateUrl: './create-rol.component.html',
  styleUrls: ['./create-rol.component.scss']
})
export class CreateRolComponent implements OnInit {

  operacion = 'Crear';
  idrol = null;
  idpais = 5;
  esContrata = false;
  esRolAgente = false;
  saving = false;

  // Modulos cargados desde BD
  modulos: any[] = [];
  modulosLoaded = false;

  // Matriz de permisos: { modulo: { permiso_ver, permiso_crear, permiso_editar, permiso_borrar } }
  permisos: any = {};

  grupoVal = new FormGroup({
    NOMBRE: new FormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(50)]),
    DESCRIPCION: new FormControl('', [Validators.maxLength(100)]),
  });

  constructor(
    private dialogRef: MatDialogRef<CreateRolComponent>,
    public Handle: Handle,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private gateway: GatewayService,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit() {
    if (this.data.operacion === 'Editar') {
      this.operacion = 'Editar';
      this.idrol = this.data.rol.idrol;
      this.grupoVal.controls.NOMBRE.setValue(this.data.rol.nombre);
      this.grupoVal.controls.DESCRIPCION.setValue(this.data.rol.descripcion || '');
      this.esContrata = this.data.rol.es_contrata === 1;
      this.esRolAgente = this.data.rol.es_rol_agente === 1;
    } else {
      this.operacion = 'Crear';
      this.idpais = this.data.rol.idpais || 5;
    }
    this.loadModulos();
  }

  loadModulos() {
    this.gateway.get('getmodulosperm', {}).then((result: any) => {
      const rows = result.rows || [];
      this.modulos = rows.map(m => ({
        id: m.id,
        key: m.codigo,
        label: m.nombre,
        icon: m.icono || 'settings',
        ver: m.tiene_ver === 1,
        crear: m.tiene_crear === 1,
        editar: m.tiene_editar === 1,
        borrar: m.tiene_borrar === 1
      }));
      // Inicializar permisos vacios
      this.modulos.forEach(m => {
        this.permisos[m.key] = { modulo_id: m.id, permiso_ver: 0, permiso_crear: 0, permiso_editar: 0, permiso_borrar: 0 };
      });
      this.modulosLoaded = true;
      // Si es editar, cargar permisos existentes
      if (this.operacion === 'Editar' && this.idrol) {
        this.loadPermisos();
      }
    }).catch(() => { this.modulosLoaded = true; });
  }

  loadPermisos() {
    this.gateway.get('getpermisos', { idrol: this.idrol }).then((result: any) => {
      const rows = result.rows || [];
      rows.forEach(p => {
        if (this.permisos[p.modulo]) {
          this.permisos[p.modulo].permiso_ver = p.permiso_ver;
          this.permisos[p.modulo].permiso_crear = p.permiso_crear;
          this.permisos[p.modulo].permiso_editar = p.permiso_editar;
          this.permisos[p.modulo].permiso_borrar = p.permiso_borrar;
        }
      });
    }).catch(() => {});
  }

  onVerChange(modKey: string) {
    // Si se desmarca "ver", desmarcar todos los demas
    if (this.permisos[modKey].permiso_ver === 0) {
      this.permisos[modKey].permiso_crear = 0;
      this.permisos[modKey].permiso_editar = 0;
      this.permisos[modKey].permiso_borrar = 0;
    }
  }

  onSubPermisoChange(modKey: string) {
    // Si se marca cualquier sub-permiso, activar "ver" automaticamente
    const p = this.permisos[modKey];
    if (p.permiso_crear || p.permiso_editar || p.permiso_borrar) {
      p.permiso_ver = 1;
    }
  }

  save() {
    if (this.saving) return;
    this.saving = true;

    const permisosArray = [];
    this.modulos.forEach(m => {
      const p = this.permisos[m.key];
      if (p.permiso_ver || p.permiso_crear || p.permiso_editar || p.permiso_borrar) {
        permisosArray.push({
          modulo_id: m.id,
          modulo: m.key,
          permiso_ver: p.permiso_ver || 0,
          permiso_crear: p.permiso_crear || 0,
          permiso_editar: p.permiso_editar || 0,
          permiso_borrar: p.permiso_borrar || 0
        });
      }
    });

    const payload = {
      nombre: this.grupoVal.controls.NOMBRE.value,
      descripcion: this.grupoVal.controls.DESCRIPCION.value || '',
      es_contrata: this.esContrata ? 1 : 0,
      es_rol_agente: this.esRolAgente ? 1 : 0,
      idpais: this.idpais,
      permisos: permisosArray
    };

    if (this.operacion === 'Editar') {
      payload['idrol'] = this.idrol;
      this.gateway.save('updaterolpermisos', payload).then((result: any) => {
        this.saving = false;
        if (result.valid) {
          this.snackBar.open('Rol actualizado', '', { duration: 3000 });
          this.dialogRef.close(true);
        } else {
          this.snackBar.open(result.data && result.data.error ? result.data.error : 'Error al actualizar', '', { duration: 4000 });
        }
      }).catch(() => {
        this.saving = false;
        this.snackBar.open('Error al actualizar', '', { duration: 4000 });
      });
    } else {
      this.gateway.save('saverolpermisos', payload).then((result: any) => {
        this.saving = false;
        if (result.valid) {
          this.snackBar.open('Rol creado', '', { duration: 3000 });
          this.dialogRef.close(true);
        } else {
          this.snackBar.open(result.data && result.data.error ? result.data.error : 'Error al crear', '', { duration: 4000 });
        }
      }).catch(() => {
        this.saving = false;
        this.snackBar.open('Error al crear', '', { duration: 4000 });
      });
    }
  }

  onNoClick() {
    this.dialogRef.close();
  }

}
